import React from 'react';
import { useTranslation } from 'react-i18next';

import whyChooseImg from '../../assets/img/Illustration-Login.png';

interface WhyChooseProps {
  licenseType: string;
  className?: string;
}

interface BenefitCard {
  title: string;
  description: string;
  icon: string;
}

const WhyChoose: React.FC<WhyChooseProps> = ({ licenseType, className = '' }) => {
  const { t } = useTranslation();

  return (
    <div className={`why-choose ${className}`}>
      <div className="why-choose-container">
        <h2 className="block-title">{t(`${licenseType}.why_choose.title`)}</h2>
        <div className="why-choose-content">
          <div className="why-choose-cards">
            <div className="how-it-works-step">
              <div className="step-content">
                <div className="step-content-inner">
                  <h3 className="step-title">{t(`${licenseType}.why_choose.card1.title`)}</h3>
                </div>
                <p className="step-description">{t(`${licenseType}.why_choose.card1.description`)}</p>
              </div>
            </div>
            
            <div className="how-it-works-step">
              <div className="step-content">
                <div className="step-content-inner">
                  <h3 className="step-title">{t(`${licenseType}.why_choose.card2.title`)}</h3>
                </div>
                <p className="step-description">{t(`${licenseType}.why_choose.card2.description`)}</p>
              </div>
            </div>
              
            <div className="how-it-works-step">
              <div className="step-content">
                <div className="step-content-inner">
                  <h3 className="step-title">{t(`${licenseType}.why_choose.card3.title`)}</h3>
                </div>
                <p className="step-description">{t(`${licenseType}.why_choose.card3.description`)}</p>
              </div>
            </div>
              
            <div className="how-it-works-step">
              <div className="step-content">
                <div className="step-content-inner">
                  <h3 className="step-title">{t(`${licenseType}.why_choose.card4.title`)}</h3>
                </div>
                <p className="step-description">{t(`${licenseType}.why_choose.card4.description`)}</p>
              </div>
            </div>
            
          </div>
          <div className="why-choose-robot">
            <img src={whyChooseImg} alt="robot" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
